import { c as _c } from "react/compiler-runtime";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { ActiveDropAction } from "@/types/dropInteractionTypes";
interface CreateDropReplyingProps {
  readonly drop: ApiDrop;
  readonly action: ActiveDropAction;
  readonly onCancel: () => void;
  readonly disabled: boolean;
}
export default function CreateDropReplying(t0) {
  const $ = _c(14);
  const {
    drop,
    action,
    onCancel,
    disabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [ActiveDropAction.REPLY]: "Replying to",
      [ActiveDropAction.QUOTE]: "Quoting"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const ACTION_LABELS = t1;
  const t2 = ACTION_LABELS[action];
  let t3;
  if ($[1] !== drop.author.handle) {
    t3 = <span className="tw-text-green tw-text-xs tw-font-semibold">{drop.author.handle}</span>;
    $[1] = drop.author.handle;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <span className="tw-text-xs tw-text-iron-400">{t2}{" "}{t3}</span>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `tw-bg-transparent tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 tw-border-0 -tw-mr-2 tw-transition tw-duration-300 tw-ease-out ${disabled ? "tw-text-iron-600 tw-cursor-not-allowed" : "tw-text-primary-400 hover:tw-text-primary-500"}`;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="tw-size-5 tw-flex-shrink-0"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== disabled || $[8] !== onCancel || $[9] !== t5) {
    t7 = <button type="button" onClick={onCancel} disabled={disabled} className={t5}>{t6}</button>;
    $[7] = disabled;
    $[8] = onCancel;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t7) {
    t8 = <div className="-tw-mt-2 tw-flex tw-justify-between tw-items-center" data-text-selection-exclude="true">{t4}{t7}</div>;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}